import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const latest = [...dramas].sort((a, b) => (a.updateTime < b.updateTime ? 1 : -1)).slice(0, 6);

export default function LatestList() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
          <i className="ri-history-line text-primary-500"></i>
          最新剧集
        </h2>
        <Link
          to="/category"
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          更多更新
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="flex flex-col divide-y divide-background-200">
        {latest.map((drama) => (
          <Link
            key={drama.id}
            to={`/detail/${drama.id}`}
            className="group flex cursor-pointer gap-3 py-3 first:pt-0 last:pb-0"
          >
            <div className="h-24 w-[68px] shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={drama.cover}
                alt={`${drama.title} 封面`}
                title={`${drama.title} 剧集封面`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex items-center gap-2">
                <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {drama.title}
                </h3>
                <span
                  className={`shrink-0 rounded px-1.5 py-0.5 text-[10px] ${
                    drama.status === "更新中"
                      ? "bg-accent-100 text-accent-800"
                      : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  {drama.status}
                </span>
              </div>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">{drama.synopsis}</p>
              <div className="mt-auto flex items-center gap-3 pt-1 text-[11px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-stack-line"></i>
                  {drama.updatedEpisodes}/{drama.totalEpisodes} 集
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  {drama.updateTime.slice(5)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i>
                  {drama.cast[0]}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}